<template>
  <Panel title="Legenda">
    <div class="container">
      <ul class="legend__items">
        <li class="legend__item">
          <div>
            <img src="images/marker-cluster.svg" alt="`Icoon van verzameling" />
          </div>
          <div class="legend__item__label">Meerdere projecten</div>
        </li>
        <li
          class="legend__item"
          v-for="(item, index) in legend.items"
          :key="index"
        >
          <div>
            <img
              :src="item.icon"
              :alt="`Icoon van punt op de kaart: ${item.label}`"
            />
          </div>
          <div class="legend__item__label">{{ item.label }}</div>
        </li>
      </ul>
    </div>
  </Panel>
</template>

<script>
import Panel from "./Panel.vue";

export default {
  name: "FilterPanel",
  components: {
    Panel,
  },
  props: {
    facets: Object,
    legend: Object,
  },
  methods: {},
};
</script>

<style scoped>
.expand-button:not(:last-child) {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-grey-20);
}
.container {
  padding: var(--padding-screen);
}

.legend__item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.legend__item__label {
  margin-left: 10px;
}

.legend__item__sublabel {
  font-size: 14px;
  margin-top: 4px;
  color: #535353;
}
</style>
